export const OrganisationCodesList = [
  {value: 'SIRET', label: 'Siret'},
  {value: 'INTERN_CODE', label: 'Code interne'}
  ]
